// imports
import React from 'react';
import { Tooltip } from 'react-tooltip';
import { ICON } from '../../assets';
import { ITraitMatching } from '../../common/types';

// interfaces / types / consts
interface Props {
  title: string;
  description: string;
  anchorSelect: string;
  traits: ITraitMatching[];
}

// exports
export default function TraitListTooltip(props: Props): JSX.Element {
  const {
    title, description, traits, anchorSelect
  } = props;
  return (
    <Tooltip anchorSelect={anchorSelect} delayShow={500} place="top" variant="light">
      <div className="tool-tip">
        <div className="heading">{title}</div>
        <div className="description wide">{description}</div>
        <div className="traits-block my-2">
          {traits?.map((trait) => (
            <div key={trait.icon} className={`trait-block ${trait.status}`}>
              <img src={ICON[trait.icon]} alt="trait" />
            </div>
          ))}
        </div>
      </div>
    </Tooltip>
  );
}
